<div class="d-flex flex-column">

  <div class="d-flex ai-center gap-2 mb-2">
    <button (click)="newBlueprint()" class="btn btn-primary align-self-start" data-testid="add-blueprint">
      <app-svg-icon type="plus" size="medium-small"/>
      <span>{{ 'global.label.add' | translate }}</span>
    </button>
    <button (click)="importBlueprint()" class="btn btn-secondary align-self-start" tooltip [tooltipText]="'global.label.import' | translate">
      <app-svg-icon type="import" size="medium-small"/>
    </button>
    <button (click)="exportBlueprint()" [disabled]="!selected()" class="btn btn-secondary align-self-start" tooltip [tooltipText]="'global.label.export' | translate">
      <app-svg-icon type="export" size="medium-small"/>
    </button>
    <div class="flex-grow-1"></div>
    <input [(ngModel)]="search" [placeholder]="'global.label.search' | translate" class="align-self-end form-control search">
  </div>

  <table class="table table-striped table-hover fixed-layout">
    <thead>
    <tr>
      <th>{{ 'complexArticleBlueprint.label.name' | translate }}</th>
      <th>{{ 'complexArticleBlueprint.label.article_no_system' | translate }}</th>
      <th>{{ 'complexArticleBlueprint.label.description' | translate }}</th>
      <th class="icons-column">{{ 'global.label.edit' | translate }}</th>
    </tr>
    </thead>
    <tbody class="blueprint-list">
    @for (blueprint of filteredBlueprints(); track $index) {

      <tr (click)="selectBlueprint(blueprint.id)" class="selectable" [attr.data-testid]="blueprint.name" [class.active]="blueprint.id == selected()?.id">
        <td class="text-truncate">{{blueprint.name}}</td>
        <td class="text-truncate">{{blueprint.articleNumberSchema.articleNumber}}</td>
        <td class="text-truncate">{{blueprint.description}}</td>
        <td class="d-flex gap-2 icons-column">
          <a><app-svg-icon type="edit-pen" (click)="editBlueprint(blueprint)"/></a>
          <a><app-svg-icon type="delete" (click)="deleteBlueprint(blueprint, $event)"/></a>
        </td>
      </tr>
    }
    </tbody>
  </table>
</div>
